import React, { useState } from 'react'

import { Form, Input, Button, InputNumber, Typography, Divider, Row, Col } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { Navigate, useNavigate } from 'react-router-dom';
import useHideMenu from '../hooks/useHideMenu';
import { getUserStorage } from '../helpers/getUserStorage';

const { Title, Text } = Typography

const Login = () => {

    useHideMenu(false)

    const [ user ] = useState(getUserStorage())

    const navigate = useNavigate()

    const onFinish = ({ agent, desk }) => {
        localStorage.setItem('agentUser', JSON.stringify({ agent, desk }))
        navigate('/desktop')
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    if (user) return <Navigate to="/desktop" />

    return (
        <>
            <Row>
                <Col span={12} offset={6}>
                    <Title level={2}>Log in</Title>
                    <Text>Enter your name and desk number</Text>
                </Col>
            </Row>
            <Divider />
            <Form
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 6,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Agent name"
                    name="agent"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your agent name!',
                        },
                    ]}
                >
                    <Input style={{ 'minWidth': 252 }} />
                </Form.Item>

                <Form.Item
                    label="Desk"
                    name="desk"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your desk number!',
                        },
                    ]}
                >
                    <InputNumber min={1} max={99} />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit" shape='round'>
                        <LoginOutlined />
                        Log in
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default Login